import React, { useMemo } from 'react';
import {
  groupValidationResults,
  suggestRequiredRoleAssignments,
  missingRequiredRoles,
} from '../adapters';

const ValidationResultsPanel = ({ validation, fields, onGoToField, onApplyRoleSuggestions }) => {
  const grouped = useMemo(
    () => (validation ? groupValidationResults(validation, fields) : null),
    [validation, fields],
  );
  const suggestions = useMemo(() => suggestRequiredRoleAssignments(fields), [fields]);
  const missing = useMemo(() => missingRequiredRoles(fields), [fields]);

  if (!grouped && missing.length === 0) return null;

  return (
    <div className={`ra-template-validation ${grouped?.ok && missing.length === 0 ? 'ok' : 'err'}`}>
      <strong>
        {grouped?.ok && missing.length === 0
          ? 'Ready to Publish'
          : 'Needs attention before publish'}
      </strong>

      {grouped && (
        <div className="ra-tpl-ready-list">
          {grouped.readyChecks.map((c) => (
            <div key={c.label} className={c.ok ? 'is-ok' : 'is-bad'}>
              {c.ok ? '✓' : '✕'} {c.label}
            </div>
          ))}
        </div>
      )}

      {missing.length > 0 && (
        <div className="ra-tpl-val-block">
          <h5>Required System Meanings</h5>
          <p className="ra-tpl-help">
            Configurable templates need these meanings assigned on Advanced → System Meaning before publish.
          </p>
          {missing.map((m) => (
            <div key={m.role} className="ra-tpl-val-item err">
              <span>✕ {m.roleLabel} not assigned</span>
            </div>
          ))}
          {suggestions.length > 0 && onApplyRoleSuggestions && (
            <div style={{ marginTop: 10 }}>
              <p className="ra-tpl-help">Suggested mappings:</p>
              <ul className="ra-tpl-help" style={{ marginTop: 4 }}>
                {suggestions.map((s) => (
                  <li key={s.role}><strong>{s.roleLabel}</strong> → {s.fieldLabel}</li>
                ))}
              </ul>
              <button
                type="button"
                className="btn-primary btn-sm"
                onClick={() => onApplyRoleSuggestions(suggestions)}
              >
                Apply suggested System Meanings
              </button>
            </div>
          )}
        </div>
      )}

      {grouped?.warnings?.length > 0 && (
        <div className="ra-tpl-val-block">
          <h5>Needs Attention</h5>
          {grouped.warnings.map((w, i) => (
            <div key={`w-${i}`} className="ra-tpl-val-item warn">
              <span>⚠ {w.message}</span>
              {w.fieldCode && <button type="button" className="btn-secondary btn-sm" onClick={() => onGoToField(w.fieldCode)}>Go to Field</button>}
            </div>
          ))}
        </div>
      )}
      {grouped?.errors?.length > 0 && (
        <div className="ra-tpl-val-block">
          <h5>Errors</h5>
          {grouped.errors.map((e, i) => (
            <div key={`e-${i}`} className="ra-tpl-val-item err">
              <span>✕ {e.message}</span>
              {e.fieldCode && <button type="button" className="btn-secondary btn-sm" onClick={() => onGoToField(e.fieldCode)}>Go to Field</button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ValidationResultsPanel;
